import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPropertyLocationHierarchyQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['uuid']['input'];
}>;


export type GetPropertyLocationHierarchyQuery = { __typename?: 'query_root', buildings: Array<{ __typename?: 'buildings', id: any, name: string, floors: Array<{ __typename?: 'floors', id: any, name: string, level_number?: number | null, rooms: Array<{ __typename?: 'rooms', id: any, name: string, room_type?: string | null, is_inspectable: boolean }> }> }> };


export const GetPropertyLocationHierarchyDocument = gql`
    query getPropertyLocationHierarchy($propertyId: uuid!) {
  buildings(where: {property_id: {_eq: $propertyId}}, order_by: {sort_order: asc}) {
    id
    name
    floors(order_by: {sort_order: asc}) {
      id
      name
      level_number
      rooms(order_by: {sort_order: asc}) {
        id
        name
        room_type
        is_inspectable
      }
    }
  }
}
    `;

/**
 * __useGetPropertyLocationHierarchyQuery__
 *
 * To run a query within a React component, call `useGetPropertyLocationHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyLocationHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyLocationHierarchyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyLocationHierarchyQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyLocationHierarchyQuery, GetPropertyLocationHierarchyQueryVariables> & ({ variables: GetPropertyLocationHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyLocationHierarchyQuery, GetPropertyLocationHierarchyQueryVariables>(GetPropertyLocationHierarchyDocument, options);
      }
export function useGetPropertyLocationHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyLocationHierarchyQuery, GetPropertyLocationHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyLocationHierarchyQuery, GetPropertyLocationHierarchyQueryVariables>(GetPropertyLocationHierarchyDocument, options);
        }
export function useGetPropertyLocationHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyLocationHierarchyQuery, GetPropertyLocationHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyLocationHierarchyQuery, GetPropertyLocationHierarchyQueryVariables>(GetPropertyLocationHierarchyDocument, options);
        }
export type GetPropertyLocationHierarchyQueryHookResult = ReturnType<typeof useGetPropertyLocationHierarchyQuery>;
export type GetPropertyLocationHierarchyLazyQueryHookResult = ReturnType<typeof useGetPropertyLocationHierarchyLazyQuery>;
export type GetPropertyLocationHierarchySuspenseQueryHookResult = ReturnType<typeof useGetPropertyLocationHierarchySuspenseQuery>;
export type GetPropertyLocationHierarchyQueryResult = Apollo.QueryResult<GetPropertyLocationHierarchyQuery, GetPropertyLocationHierarchyQueryVariables>;